module.exports = __webpack_public_path__ + "static/media/Decisions_Step5_Image11.1d83d770.webp";